export enum ChainName {
  PolygonMumbai = "polygon-mumbai",
  ArbitrumGoerli = "arbitrum-goerli",
  Arbitrum = "arbitrum",
}
